import { useState } from 'react'

import { useUnit } from 'effector-react'

import { $summary } from '@/models/chattingUI/chatSummary.ts'
import SummarizeIcon from '@/modules/chatting/icons/summarize.svg'

export const LastChatSummary = () => {
  const summary = useUnit($summary)
  const [isExpanded, setIsExpanded] = useState(false)

  if (!summary) return null

  const displayedContent =
    isExpanded || summary.length < 100 ? summary : summary.slice(0, 100) + '...'

  return (
    <div className="bg-card space-y-4 rounded-md p-3">
      <div className="bg-secondary-50 text-title dark:bg-secondary-600 flex items-center justify-between gap-2 rounded-md p-2">
        <SummarizeIcon />
        <p className="flex-1 text-sm font-bold">Summarized Chat Export</p>
      </div>
      <div className="break-words">
        {displayedContent}
        {summary.length > 100 && (
          <>
            {' '}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-primary-500 hover:underline"
            >
              {isExpanded ? 'show less' : 'show more'}
            </button>
          </>
        )}
      </div>
    </div>
  )
}
